@if (visible()) {
<div id="loader" class="loader-overlay">
  <div class="spinner"></div>
</div>
}